import React, { useState, useRef, useEffect } from "react";
import ChatMessageInput from "./ChatMessageInput";
import ChatMessageList from "./ChatMessageList";
import { isMobileOrTablet } from "../Views/MobileClassRenderer";
import { Collapse } from "react-bootstrap";

const CollapseType = {
  COLLAPSED: "collapsed",
  COLLAPSING: "collapsing",
};

export default function ChatWindowView({
  urlParams,
  type,
  mutedList,
  messageCollection,
  me,
  onCreateVideoRoom,
  videoBtn,
  memberList,
  tabIsOpen,
  setTabIsOpen,
  unreadMessageCount,
  order,
  archiveChat,
  forceOpen,
  isCorporateAgent,
  tabTitle,
  corporateChatAvailability,
}) {
  const { eventSlug, pageSlug } = urlParams;
  const [filter, setFilter] = useState(false);
  const [collapseState, setCollapseState] = useState();
  const toggleBtn = useRef(null);

  const handleTabToggle = () => {
    setTabIsOpen(!tabIsOpen);
  };

  const getToggleId = () => {
    switch (type) {
      case "public":
        return "public-chat-toggle";
      case "private":
        return `private-chat-toggle-${urlParams.inboxUUID}`;
      case "corporate":
        return `corporate-chat-toggle`;
      default:
        return "no-type";
    }
  };

  const isPublic = () => {
    return type === "public";
  };

  const isPrivate = () => {
    return type === "private";
  };

  const isCorporate = () => {
    return type === "corporate";
  };

  const privateChatTitle = () => {
    const chatTitle = memberList.map((member, i) => {
      const last = i === memberList.length - 1;
      const firstName = member.first_name ? member.first_name : "";
      const lastName = member.last_name[0] ? member.last_name[0] : "";
      return `${firstName} ${lastName}${!last ? "," : ""} `;
    });

    return <div className="text-white px-2">{chatTitle}</div>;
  };

  const shouldForceOpen = () =>
    typeof forceOpen === "function"
      ? forceOpen()
      : forceOpen && toggleBtn
      ? true
      : false;

  useEffect(() => {
    if (forceOpen) {
      setTabIsOpen(true);
    }
  }, [forceOpen]);

  const firstMember = () =>
    memberList.length > 0
      ? `${memberList[0].first_name} ${memberList[0].last_name}`
      : "";
  const remainingMemberCount = () =>
    memberList.length > 0 ? `${memberList.slice(1).length}` : "";

  const renderMobileView = () => {
    return (
      <div
        className="chat-window"
        style={{
          order: typeof order !== undefined ? order : 0,
        }}
      >
        <div className="chat-list-input-wrapper">
          {messageCollection && (
            <ChatMessageList
              filter={filter}
              messageCollection={messageCollection}
              type={type}
              tabIsOpen={tabIsOpen}
              mutedList={mutedList}
            />
          )}
          <div className="d-flex container">
            <div className="row w-100">
              {messageCollection && (
                <ChatMessageInput
                  messageCollection={messageCollection}
                  mutedList={mutedList}
                  onClick={handleTabToggle}
                  type={type}
                  createVideoRoom={onCreateVideoRoom}
                  videoBtn={videoBtn}
                  filter={filter}
                  setFilter={setFilter}
                  event={eventSlug}
                  page={pageSlug}
                  urlParams={urlParams}
                  isCorporateAgent={isCorporateAgent}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  function getIndicatorClass() {
    if (corporateChatAvailability == true) return "is-online";
    return "is-offline";
  }

  return (
    <>
      {isMobileOrTablet() ? (
        renderMobileView()
      ) : (
        <div
          className="me-3"
          style={{
            order: typeof order !== undefined ? order : 0,
          }}
        >
          <div
            className={`chat-window ${
              isCorporateAgent ? "corporate-chat-window" : "collapsable-chat"
            }`}
          >
            <button
              ref={toggleBtn}
              style={{
                cursor: tabIsOpen ? "default" : "pointer",
              }}
              className={`btn w-100 text-white text-start live-chat-button focus-outline-red ${
                tabIsOpen ? "active" : ""
              }`}
              onClick={handleTabToggle}
              type="button"
            >
              {isPublic() && "Live Chat"}
              {isPrivate() && (
                <span className=" member-count dropup">
                  <span className="dropdown-toggle caret-off bg-transparent border-0">
                    <span className="chat-title">
                      {`${firstMember()} ${
                        remainingMemberCount() > 0
                          ? "and " + remainingMemberCount() + " more"
                          : ""
                      } `}
                    </span>

                    {unreadMessageCount > 0 && (
                      <span className="chat-indicator-unread float-end">
                        {unreadMessageCount > 0 ? `${unreadMessageCount}` : ""}
                      </span>
                    )}
                  </span>

                  {remainingMemberCount() > 0 && (
                    <span className="dropdown-menu member-dropup mb-3 text-dark">
                      {privateChatTitle()}
                    </span>
                  )}
                </span>
              )}
              {isCorporate() && (
                <span className="member-count dropup">
                  <span className={`rounded-circle online-indicator ${getIndicatorClass()}`}>
                  </span>
                  <span className="chat-title">{tabTitle}</span>
                  <span className="dropdown-toggle caret-off bg-transparent border-0">
                    {unreadMessageCount > 0 && (
                      <span className="chat-indicator-unread float-end">
                        {unreadMessageCount > 0 ? `${unreadMessageCount}` : ""}
                      </span>
                    )}
                  </span>
                </span>
              )}

              {tabIsOpen && isPrivate() && (
                <button
                  className={`float-end chat-window-control chat-window-control__close-btn focus-outline-purple me-1`}
                  onClick={() => archiveChat()}
                >
                  <img
                    src="/assets/closechat.svg"
                    alt=""
                    width="9"
                    height="9"
                  />
                </button>
              )}

              {tabIsOpen && (
                <button
                  className={`float-end chat-window-control chat-window-control__minimize-btn focus-outline-purple ${
                    !isPrivate() ? "me-1" : ""
                  }`}
                  onClick={handleTabToggle}
                  type="button"
                >
                  <img
                    src="/assets/chatminimize.svg"
                    alt=""
                    width="9"
                    height="9"
                    id="minimise-chat-icon"
                  />
                </button>
              )}
            </button>
            <Collapse in={tabIsOpen} dimension="height">
              <div className="collapse-wrapper">
                <div className="chat-list-input-wrapper">
                  {messageCollection && (
                    <ChatMessageList
                      filter={filter}
                      messageCollection={messageCollection}
                      type={type}
                      tabIsOpen={tabIsOpen}
                      mutedList={mutedList}
                    />
                  )}
                  <div className="d-flex container">
                    <div className="row w-100">
                      {messageCollection && (
                        <ChatMessageInput
                          messageCollection={messageCollection}
                          mutedList={mutedList}
                          onClick={handleTabToggle}
                          type={type}
                          createVideoRoom={onCreateVideoRoom}
                          videoBtn={videoBtn}
                          filter={filter}
                          setFilter={setFilter}
                          event={eventSlug}
                          page={pageSlug}
                          urlParams={urlParams}
                          isCorporateAgent={isCorporateAgent}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      )}
    </>
  );
}
